export default __webpack_public_path__ + "static/media/Icon-Customers.2e4a0cc2.svg";